/* ============================================================
   White Nights — global.js  (vanilla, no dependencies)
   Wires the design to Shopify's Cart AJAX API + UI behaviour.
   ============================================================ */
(function () {
  'use strict';

  var T = window.theme || {};
  var cfg = T.settings || {};
  var strings = T.strings || {};

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '₹{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n, p, t, d) {
      n = (n || 0).toString();
      p = p == null ? 2 : p; t = t == null ? ',' : t; d = d == null ? '.' : d;
      var parts = (parseInt(n, 10) / 100).toFixed(p).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      var centsStr = parts[1] ? d + parts[1] : '';
      return dollars + centsStr;
    }
    switch ((format.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      default: value = defaultTo(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts))
      .then(function (r) { return r.json(); });
  }

  /* ---------- focus trap (accessibility) — used by cart drawer, mobile menu, modals ---------- */
  var FocusTrap = (function () {
    var active = null, lastFocused = null;
    function focusable(container) {
      return $all('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', container)
        .filter(function (el) { return el.offsetParent !== null; });
    }
    function onKeydown(e) {
      if (!active) return;
      if (e.key === 'Escape') { e.preventDefault(); active.onEscape && active.onEscape(); return; }
      if (e.key !== 'Tab') return;
      var items = focusable(active.container);
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    return {
      trap: function (container, onEscape) {
        if (!container) return;
        lastFocused = document.activeElement;
        active = { container: container, onEscape: onEscape };
        document.addEventListener('keydown', onKeydown);
        var items = focusable(container);
        (items[0] || container).focus();
      },
      release: function () {
        document.removeEventListener('keydown', onKeydown);
        active = null;
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
        lastFocused = null;
      }
    };
  })();

  /* ============================================================
     CART
     ============================================================ */
  var Favorites = (function () {
    var KEY = 'wn_favorites';
    function get() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function set(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    function has(id) { return get().indexOf(String(id)) > -1; }
    function toggle(id) {
      id = String(id);
      var list = get();
      var i = list.indexOf(id);
      if (i > -1) { list.splice(i, 1); } else { list.push(id); }
      set(list);
      return has(id);
    }
    function paint() {
      $all('[data-favorite-toggle]').forEach(function (btn) {
        btn.classList.toggle('is-active', has(btn.getAttribute('data-favorite-toggle')));
      });
      var count = get().length;
      $all('[data-favorites-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }
    function applyFavoritesPageFilter() {
      var wrap = $('[data-favorites-grid]');
      if (!wrap) return;
      var saved = get();
      var cards = $all('[data-favorite-id]', wrap);
      var shown = 0;
      cards.forEach(function (card) {
        var match = saved.indexOf(card.getAttribute('data-favorite-id')) > -1;
        card.style.display = match ? '' : 'none';
        if (match) shown++;
      });
      var empty = $('[data-favorites-empty]');
      if (empty) empty.style.display = shown === 0 ? '' : 'none';
    }
    return { get: get, has: has, toggle: toggle, paint: paint, applyFavoritesPageFilter: applyFavoritesPageFilter };
  })();

  var Cart = {
    open: function () {
      var ov = $('#CartOverlay'), dr = $('#CartDrawer');
      if (!dr) { window.location.href = T.routes.cart_url || '/cart'; return; }
      ov && ov.classList.add('is-open');
      dr.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      FocusTrap.trap(dr, function () { Cart.close(); });
      this.refresh();
    },
    close: function () {
      var ov = $('#CartOverlay'), dr = $('#CartDrawer');
      ov && ov.classList.remove('is-open');
      dr && dr.classList.remove('is-open');
      document.body.style.overflow = '';
      FocusTrap.release();
    },
    add: function (id, qty) {
      // Cart.open() already refreshes — don't also refresh here, that fired two
      // near-simultaneous /cart.js requests that could resolve out of order and
      // stomp the correct render with a stale one (see the render() note below).
      return fetchJSON((T.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function () { Cart.open(); });
    },
    buyNow: function (id, qty) {
      return fetchJSON((T.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function () { window.location.href = '/checkout'; });
    },
    change: function (key, qty) {
      return fetchJSON((T.routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST', body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (cart) { Cart.render(cart); return cart; });
    },
    updateNote: function (note) {
      return fetchJSON((T.routes.cart_update_url || '/cart/update') + '.js', {
        method: 'POST', body: JSON.stringify({ note: note })
      });
    },
    setAttribute: function (key, val) {
      var attrs = {}; attrs[key] = val;
      return fetchJSON((T.routes.cart_update_url || '/cart/update') + '.js', {
        method: 'POST', body: JSON.stringify({ attributes: attrs })
      });
    },
    refresh: function () {
      return fetchJSON((T.routes.cart_url || '/cart') + '.js').then(function (cart) { Cart.render(cart); return cart; });
    },
    render: function (cart) {
      // bag counters
      $all('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });

      // free shipping progress — every bar on the page (drawer + full cart page can
      // both be present in the DOM at once) stays in sync off the same cart object.
      // Runs even on an empty cart so the bars reset instead of freezing stale.
      if (cfg.free_shipping_bar) {
        var thr = parseInt(cfg.free_shipping_threshold, 10) || 0;
        var remain = Math.max(0, thr - cart.total_price);
        var unlocked = thr > 0 && remain === 0;
        var msg = unlocked
          ? (strings.ship_unlocked || '✦ You’ve unlocked free shipping')
          : (strings.ship_progress || 'You’re {{ amount }} away from free shipping').replace('{{ amount }}', formatMoney(remain));
        var pct = thr ? Math.min(100, Math.round(cart.total_price / thr * 100)) : 100;
        $all('[data-ship-root]').forEach(function (root) {
          root.classList.toggle('is-complete', unlocked);
          var msgEl = root.querySelector('[data-ship-msg]');
          var fillEl = root.querySelector('[data-ship-fill]');
          if (msgEl) msgEl.textContent = msg;
          if (fillEl) fillEl.style.width = pct + '%';
        });
      }

      // bundle-discount progress — mirrors an Admin > Discounts automatic discount
      // (amount off a collection once a minimum quantity from it is in the cart)
      if (cfg.bundle_bar_enabled) {
        var bundleIds = (cfg.bundle_bar_product_ids || []).map(String);
        var bundleQty = cart.items.reduce(function (sum, it) {
          return bundleIds.indexOf(String(it.product_id)) > -1 ? sum + it.quantity : sum;
        }, 0);
        var minQty = parseInt(cfg.bundle_bar_min_qty, 10) || 0;
        var bundleRemain = Math.max(0, minQty - bundleQty);
        var bundleUnlocked = minQty > 0 && bundleRemain === 0;
        var bundleAmount = formatMoney(parseInt(cfg.bundle_bar_discount_amount, 10) || 0);
        var bundleCollection = cfg.bundle_bar_collection_title || '';
        var bundlePercent = cfg.bundle_bar_discount_percent || 0;
        var bundleMsg = bundleUnlocked
          ? (strings.bundle_unlocked || '✦ {{ percent }}% off your {{ qty }} {{ collection }} tees').replace('{{ percent }}', bundlePercent).replace('{{ qty }}', minQty).replace('{{ collection }}', bundleCollection)
          : (strings.bundle_progress || 'Add {{ n }} more from {{ collection }} — save {{ amount }}').replace('{{ n }}', bundleRemain).replace('{{ collection }}', bundleCollection).replace('{{ amount }}', bundleAmount);
        var bundlePct = minQty ? Math.min(100, Math.round(bundleQty / minQty * 100)) : 100;
        $all('[data-bundle-root]').forEach(function (root) {
          root.classList.toggle('is-complete', bundleUnlocked);
          var msgEl = root.querySelector('[data-bundle-msg]');
          var fillEl = root.querySelector('[data-bundle-fill]');
          if (msgEl) msgEl.textContent = bundleMsg;
          if (fillEl) fillEl.style.width = bundlePct + '%';
        });
      }

      var body = $('#CartBody'); if (!body) return;
      // write into #CartLines specifically, never replace #CartBody's own innerHTML —
      // doing that used to delete #CartLines itself, so any later render calling
      // $('#CartLines') found nothing and silently stopped updating the item list
      // (subtotal/shipping bar kept working since those are separate elements).
      var listEl = $('#CartLines');
      var foot = $('#CartFoot');

      if (cart.item_count === 0) {
        if (listEl) listEl.innerHTML = '<div class="cart-empty"><p>' + (strings.cart_empty || 'Your bag is empty.') + '</p><a class="link-underline mt-m" href="' + (T.routes.all_products || '/collections/all') + '">' + (strings.cart_continue || 'Continue shopping') + '</a></div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = '';

      // line items
      var rows = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="' + it.product_title + '">' : '';
        var opts = it.options_with_values ? it.options_with_values.map(function (o) { return o.value; }).join(' · ') : '';
        return '' +
          '<div class="line" data-key="' + it.key + '">' +
            '<div class="line__media">' + img + '</div>' +
            '<div style="flex:1">' +
              '<div class="line__top">' +
                '<div class="line__title">' + it.product_title + '</div>' +
                '<button class="line__remove" data-line-remove>' + (strings.remove || 'Remove') + '</button>' +
              '</div>' +
              '<div class="line__variant">' + opts + '</div>' +
              '<div class="line__bottom">' +
                '<div class="qty">' +
                  '<button data-qty-dec aria-label="Decrease">−</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button data-qty-inc aria-label="Increase">+</button>' +
                '</div>' +
                '<span>' + formatMoney(it.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');

      if (listEl) listEl.innerHTML = rows;
      var sub = $('#CartSubtotal'); if (sub) sub.textContent = formatMoney(cart.total_price);
      var coBtn = $('#CartCheckoutAmount'); if (coBtn) coBtn.textContent = formatMoney(cart.total_price);
      // restore note
      var noteEl = $('#CartNote'); if (noteEl && cart.note) noteEl.value = cart.note;
    }
  };
  window.WNCart = Cart;

  /* ---------- event delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // open/close cart
    if (t.closest('[data-cart-toggle]')) { e.preventDefault(); Cart.open(); return; }
    if (t.closest('[data-cart-close]') || t.id === 'CartOverlay') { Cart.close(); return; }

    // add to cart (cross-sell / quick buttons with data-variant-id)
    var addBtn = t.closest('[data-add-variant]');
    if (addBtn) { e.preventDefault(); Cart.add(addBtn.getAttribute('data-add-variant'), 1); return; }

    // buy now — quick buttons that add + go straight to checkout (product cards)
    var buyBtn = t.closest('[data-buy-now-variant]');
    if (buyBtn) { e.preventDefault(); Cart.buyNow(buyBtn.getAttribute('data-buy-now-variant'), 1); return; }

    // qty controls inside drawer
    var line = t.closest('.line');
    if (line) {
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('.qty span');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      // removals play a fade/slide-out first (.is-removing, matches the CSS
      // transition on .line) so the row visibly leaves instead of just vanishing
      // the instant the request resolves
      if (t.closest('[data-qty-inc]')) { Cart.change(key, current + 1); return; }
      if (t.closest('[data-qty-dec]')) {
        var next = Math.max(0, current - 1);
        if (next === 0) { line.classList.add('is-removing'); setTimeout(function () { Cart.change(key, 0); }, 220); }
        else { Cart.change(key, next); }
        return;
      }
      if (t.closest('[data-line-remove]')) {
        line.classList.add('is-removing');
        setTimeout(function () { Cart.change(key, 0); }, 220);
        return;
      }
    }

    // favorite / heart toggle
    var fav = t.closest('[data-favorite-toggle]');
    if (fav) {
      e.preventDefault();
      var nowActive = Favorites.toggle(fav.getAttribute('data-favorite-toggle'));
      fav.classList.toggle('is-active', nowActive);
      Favorites.paint();
      Favorites.applyFavoritesPageFilter();
      return;
    }

    // quick view
    var qv = t.closest('[data-quick-view]');
    if (qv) { e.preventDefault(); QuickView.open(qv.getAttribute('data-quick-view')); return; }

    // mobile menu
    if (t.closest('[data-menu-open]')) { MobileMenu.open(); return; }
    if (t.closest('[data-menu-close]') || t.classList.contains('mobile-nav__overlay')) { MobileMenu.close(); return; }

    // mobile sticky add-to-cart -> submit the PDP form
    if (t.closest('[data-mobile-add]')) {
      e.preventDefault();
      var pform = $('[data-product-form]');
      if (pform) { if (pform.requestSubmit) pform.requestSubmit(); else pform.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      return;
    }

    // modal close
    if (t.closest('[data-modal-close]') || t.hasAttribute('data-modal-overlay')) {
      var m = t.closest('.modal'); if (m) m.classList.remove('is-open');
      document.body.style.overflow = ''; return;
    }

    // open age / promo from footer
    if (t.closest('[data-open-age]')) { openModal('AgeModal'); return; }
    if (t.closest('[data-open-promo]')) { openModal('PromoModal'); return; }
    if (t.closest('[data-open-size-chart]')) { openModal('SizeChartModal'); return; }

    // image zoom (PDP)
    if (t.closest('[data-zoom]')) { Zoom.toggle(t.closest('[data-zoom]')); return; }
  });

  // product form submit (PDP add to cart / buy now)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    // e.submitter is the actual button clicked — without it, "Buy now" (name="checkout")
    // silently behaved like "Add to bag" since both share the same form
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var isCheckout = btn && btn.name === 'checkout';
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '…'; }
    var reset = function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } };
    var action = isCheckout ? Cart.buyNow(id, qty) : Cart.add(id, qty);
    action.then(function () { if (!isCheckout) reset(); }).catch(reset);
  });

  // cart note (debounced)
  document.addEventListener('input', function (e) {
    if (e.target.id === 'CartNote') {
      clearTimeout(window._noteT);
      var v = e.target.value;
      window._noteT = setTimeout(function () { Cart.updateNote(v); }, 500);
    }
  });

  /* ============================================================
     MOBILE MENU
     ============================================================ */
  var MobileMenu = {
    open: function () {
      var nav = $('#MobileNav'), ov = $('.mobile-nav__overlay');
      if (ov) { ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('is-open'); }); }
      if (nav) nav.classList.add('is-open');
      var btn = $('[data-menu-open]'); if (btn) btn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (nav) FocusTrap.trap(nav, function () { MobileMenu.close(); });
    },
    close: function () {
      var nav = $('#MobileNav'), ov = $('.mobile-nav__overlay');
      if (nav) nav.classList.remove('is-open');
      if (ov) { ov.classList.remove('is-open'); setTimeout(function () { ov.hidden = true; }, 300); }
      var btn = $('[data-menu-open]'); if (btn) btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      FocusTrap.release();
    }
  };

  /* ============================================================
     SCROLL REVEALS
     ============================================================ */
  function initReveals() {
    var els = $all('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  window.WNInitReveals = initReveals;

  /* ============================================================
     QUICK VIEW  (Section Rendering API)
     ============================================================ */
  var QuickView = {
    open: function (handle) {
      var modal = $('#QuickViewModal'); if (!modal) return;
      var body = modal.querySelector('[data-quick-view-content]');
      body.innerHTML = '<div style="padding:60px;text-align:center" class="muted">Loading…</div>';
      openModal('QuickViewModal');
      fetch('/products/' + handle + '?section_id=quick-view')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.shopify-section') || doc.body;
          body.innerHTML = content.innerHTML;
          if (window.WNInitProduct) window.WNInitProduct(body);
        })
        .catch(function () { body.innerHTML = '<div style="padding:60px" class="muted">Could not load product.</div>'; });
    }
  };

  /* ============================================================
     IMAGE ZOOM (PDP)
     ============================================================ */
  var Zoom = {
    toggle: function (el) {
      var src = el.getAttribute('data-zoom-src') || (el.querySelector('img') && el.querySelector('img').src);
      if (!src) return;
      var existing = $('#ZoomOverlay');
      if (existing) { existing.remove(); document.body.style.overflow = ''; return; }
      var ov = document.createElement('div');
      ov.id = 'ZoomOverlay';
      ov.style.cssText = 'position:fixed;inset:0;background:rgba(33,29,24,.92);z-index:120;display:grid;place-items:center;cursor:zoom-out;padding:40px';
      ov.innerHTML = '<img src="' + src + '" style="max-width:90%;max-height:90%;object-fit:contain">';
      ov.addEventListener('click', function () { ov.remove(); document.body.style.overflow = ''; });
      document.body.appendChild(ov);
      document.body.style.overflow = 'hidden';
    }
  };

  /* ============================================================
     MODALS (age gate + promo popup)
     ============================================================ */
  function openModal(id) { var m = document.getElementById(id); if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; FocusTrap.trap(m, function () { closeModal(id); }); } }
  function closeModal(id) { var m = document.getElementById(id); if (m) { m.classList.remove('is-open'); document.body.style.overflow = ''; FocusTrap.release(); } }

  document.addEventListener('DOMContentLoaded', function () {
    Cart.refresh();
    Favorites.paint();
    Favorites.applyFavoritesPageFilter();

    // PDP variant + gallery
    initProduct(document);
    initFacets();
    initReveals();
    RecentlyViewed.run();

    // Age gate
    var age = $('#AgeModal');
    if (age && age.getAttribute('data-enabled') === 'true' && !sessionStorage.getItem('wn_age')) {
      openModal('AgeModal');
    }
    var ageYes = $('[data-age-confirm]');
    if (ageYes) ageYes.addEventListener('click', function () {
      sessionStorage.setItem('wn_age', '1'); closeModal('AgeModal'); maybePromo(1600);
    });

    if (!age || sessionStorage.getItem('wn_age')) maybePromo(3500);
  });

  function maybePromo(delay) {
    var promo = $('#PromoModal');
    if (!promo || promo.getAttribute('data-enabled') !== 'true') return;
    if (sessionStorage.getItem('wn_promo')) return;
    setTimeout(function () {
      openModal('PromoModal');
      sessionStorage.setItem('wn_promo', '1');
    }, delay || 3000);
  }

  /* ============================================================
     PRODUCT PAGE — variant selection + gallery + tabs
     ============================================================ */
  function initProduct(scope) {
    scope = scope || document;
    var root = (scope.matches && scope.matches('[data-product-root]')) ? scope : scope.querySelector('[data-product-root]');
    if (!root) return;
    var variants = JSON.parse(root.getAttribute('data-variants') || '[]');
    var form = root.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var addBtn = form && form.querySelector('[type="submit"]');

    function selectedOptions() {
      return $all('[data-option-selector]', root).map(function (group) {
        var checked = group.querySelector('input:checked') || group.querySelector('[data-option-value].is-active');
        return checked ? (checked.value || checked.getAttribute('data-option-value')) : null;
      });
    }
    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      // keep mobile sticky bar price in sync (it lives outside the product root)
      var mAtcPrice = document.querySelector('[data-mobile-atc] [data-pdp-price]');
      if (mAtcPrice) mAtcPrice.textContent = formatMoney(match.price);
      var mAdd = document.querySelector('[data-mobile-add]');
      if (mAdd) {
        mAdd.disabled = !match.available;
        mAdd.textContent = match.available ? (strings.add_to_cart || 'Add to bag') : (strings.sold_out || 'Sold out');
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (strings.add_to_cart || 'Add to bag') : (strings.sold_out || 'Sold out');
      }
    }

    // gallery — exactly one photo, swapped by the selected colour (no multi-photo
    // carousel/dots: a colour ever shows only its own first matching photo, or the
    // first shared one if it has none)
    var galleryEl = root.querySelector('[data-pdp-gallery]');
    var colourIndex = parseInt(root.getAttribute('data-colour-index') || '0', 10);
    var allImages = [];
    if (galleryEl) {
      try { allImages = JSON.parse(galleryEl.getAttribute('data-images') || '[]'); } catch (e) { allImages = []; }
    }

    function currentColour() {
      var grp = $all('[data-option-selector]', root)[colourIndex];
      if (!grp) return '';
      var active = grp.querySelector('[data-option-value].is-active');
      return active ? active.getAttribute('data-option-value') : '';
    }

    // this colour's own photo first, falling back to the first shared (no-colour)
    // photo — independent of raw Media order, since that order is also used to
    // pick the catalog grid's cover photo (product.featured_media = whichever
    // image is first) and a shared cover image sitting first there would
    // otherwise always win here too, making colour selection look like it does nothing.
    function pickGalleryImage(colour) {
      var match = allImages.filter(function (img) { return img.colour === colour; })[0];
      var shared = allImages.filter(function (img) { return !img.colour; })[0];
      return match || shared || allImages[0];
    }

    function renderGallery(colour) {
      if (!galleryEl || !allImages.length) return;
      var pick = pickGalleryImage(colour);
      if (!pick) return;
      var mainWrap = galleryEl.querySelector('[data-pdp-main]');
      if (!mainWrap) return;

      // always a fresh <img>, never a mutated .src on the existing one — mutating
      // .src silently didn't update the visible photo (only the zoom overlay, which
      // reads data-zoom-src live), so rebuild the element instead.
      var oldImg = mainWrap.querySelector('img');
      var placeholder = mainWrap.querySelector('.media__ph');
      var newImg = document.createElement('img');
      newImg.src = pick.full;
      newImg.alt = oldImg ? (oldImg.getAttribute('alt') || '') : '';
      if (oldImg) { oldImg.replaceWith(newImg); } else {
        if (placeholder) placeholder.remove();
        mainWrap.insertBefore(newImg, mainWrap.firstChild);
      }
      mainWrap.setAttribute('data-zoom-src', pick.full);
    }

    // correct the main photo on load too, in case a shared image (e.g. a cover
    // shot placed first for the catalog grid) would otherwise outrank the
    // current colour's own photo — same reordering renderGallery() applies
    if (galleryEl) renderGallery(currentColour());

    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-selector]')) update(); });
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-option-value]');
      if (sw) {
        var grp = sw.closest('[data-option-selector]');
        var groupIndex = $all('[data-option-selector]', root).indexOf(grp);
        $all('[data-option-value]', grp).forEach(function (x) { x.classList.remove('is-active'); });
        sw.classList.add('is-active');
        update();
        if (groupIndex === colourIndex) renderGallery(currentColour());
        return;
      }
      // colour swatches (separate products, same "page") swap in place with no URL
      // change at all — the style switch does the same swap but treats it as a real
      // navigation (URL/title/history update), since Normal vs Oversized are different
      // enough to deserve their own address; colours within one design aren't. Both are
      // plain <button>s reading a data-swap-url, not <a href> — an anchor's click here
      // was reaching the browser's default navigation despite e.preventDefault() (still
      // unclear why), so there's nothing left to "prevent": buttons never navigate.
      var colourBtn = e.target.closest('[data-colour-swatch]');
      if (colourBtn) {
        colourBtn.classList.add('is-loading');
        swapProductRoot(colourBtn.getAttribute('data-swap-url'), false);
        return;
      }
      var styleBtn = e.target.closest('[data-style-target]');
      if (styleBtn) {
        styleBtn.classList.add('is-loading');
        swapProductRoot(styleBtn.getAttribute('data-swap-url'), true);
      }
    });

    // fetches another product's `main` section and replaces this one's root with it.
    // updateAddress true = treat it as a real navigation (title/canonical/og/history,
    // used by the style switch). false = pure content swap, URL never changes (used by
    // colour swatches, so switching colour never leaves/changes "the page").
    function swapProductRoot(url, updateAddress) {
      return fetch(url + '?section_id=main')
        .then(function (r) {
          if (!r.ok) throw new Error('section fetch returned ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRoot = doc.querySelector('[data-product-root]');
          if (!newRoot) throw new Error('no [data-product-root] in section response');
          var newAtc = doc.querySelector('[data-mobile-atc]');
          var oldAtc = document.querySelector('[data-mobile-atc]');
          // anchor to where the product block currently sits in the viewport (not a
          // raw scrollY number) and restore that same viewport offset afterwards —
          // self-corrects even if the swapped-in block's height differs slightly,
          // rather than trusting the page's total height to stay identical. Checked
          // again after paint (rAF) in case anything settles a frame late.
          var anchorOffset = root.getBoundingClientRect().top;
          root.replaceWith(newRoot);
          if (newAtc && oldAtc) oldAtc.replaceWith(newAtc);
          window.WNInitProduct(newRoot);
          // only for colour swaps — the style switch (updateAddress true) does its
          // own scrollIntoView below, which this would otherwise fight with
          if (!updateAddress) {
            var restoreScroll = function () {
              var delta = newRoot.getBoundingClientRect().top - anchorOffset;
              if (delta !== 0) window.scrollBy(0, delta);
            };
            restoreScroll();
            requestAnimationFrame(function () { requestAnimationFrame(restoreScroll); });
          }

          if (updateAddress) {
            var newHeading = newRoot.querySelector('.pdp__info h1');
            if (newHeading) {
              var titleParts = document.title.split(/\s[–-]\s/);
              var suffix = titleParts.slice(1).join(' – ');
              document.title = suffix ? (newHeading.textContent.trim() + ' – ' + suffix) : newHeading.textContent.trim();
            }
            var canonical = document.querySelector('link[rel="canonical"]');
            if (canonical) canonical.setAttribute('href', url);
            var ogUrl = document.querySelector('meta[property="og:url"]');
            if (ogUrl) ogUrl.setAttribute('content', url);
            history.pushState({ wnProductSwap: true }, '', url);
            newRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        })
        .catch(function (err) {
          console.error('Product swap failed, falling back to a normal link:', err);
          window.location.href = url;
        });
    }

    update();
  }
  window.WNInitProduct = initProduct;
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.wnStyleSwitch) window.location.reload();
  });

  /* ============================================================
     RECENTLY VIEWED (localStorage + Section Rendering)
     ============================================================ */
  var RecentlyViewed = {
    KEY: 'wn_recent',
    read: function () { try { return JSON.parse(localStorage.getItem(this.KEY)) || []; } catch (e) { return []; } },
    write: function (a) { try { localStorage.setItem(this.KEY, JSON.stringify(a.slice(0, 8))); } catch (e) {} },
    run: function () {
      var list = this.read();
      var current = (window.WNRecentQueue || []);
      // record current product(s)
      current.forEach(function (h) {
        list = list.filter(function (x) { return x !== h; });
        list.unshift(h);
      });
      if (current.length) this.write(list);

      var container = document.getElementById('RecentlyViewed');
      var section = document.getElementById('RecentlyViewedSection');
      if (!container || !section) return;

      // stay hidden — explicitly, not just "leave whatever it already was" — until
      // real card HTML has actually landed in the container below
      section.hidden = true;

      var toShow = this.read().filter(function (h) { return current.indexOf(h) === -1; }).slice(0, 4);
      if (!toShow.length) return;
      Promise.all(toShow.map(function (h) {
        return fetch('/products/' + h + '?section_id=card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        var cards = [];
        htmls.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('.card');
          if (card) cards.push(card.outerHTML);
        });
        if (cards.length) {
          container.innerHTML = cards.join('');
          section.hidden = false;
        }
      });
    }
  };

  /* ============================================================
     COLLECTION — auto-submit facets / sort
     ============================================================ */
  function initFacets() {
    var form = $('#FacetForm'); if (!form) return;
    form.addEventListener('change', function () { form.submit(); });
    var sort = $('#SortBy');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }
})();
